<div class="search-params-bar">
  @if (facade.hasDepartureCities) {
    <div class="search-params-group" style="min-width: 210px">
      <button type="button"
              class="search-pill search-pill--departure"
              (click)="toggleDropdown('departureCity', $event)">
        <span class="pill-label">Город вылета:</span>
        <span class="pill-value">{{ facade.departureCityLabel }}</span>
      </button>
      @if (openedDropdown === 'departureCity') {
        <div class="search-dropdown search-dropdown--departure-cities" (click)="$event.stopPropagation()">
          @for (city of facade.departureCities; track city.id) {
            <button type="button"
                    class="search-dropdown-option"
                    [class.search-dropdown-option--active]="city.id === facade.departureCityId"
                    (click)="selectDepartureCity(city.id)">
              {{ city.name }}
            </button>
          }
        </div>
      }
    </div>
  }

  <div class="search-params-group" style="min-width: 210px">
    <button type="button"
            class="search-pill search-pill--dates"
            [class.search-pill--middle]="facade.hasDepartureCities"
            (click)="toggleDropdown('dates', $event)">
      <span class="pill-label">{{ facade.checkInTitle }}</span>
      <span class="pill-value">{{ facade.checkInPillLabel }}</span>
    </button>
    @if (openedDropdown === 'dates') {
      <div class="search-dropdown search-dropdown--dates" (click)="$event.stopPropagation()">
        <app-short-search-dates-dropdown
          [months]="facade.calendarMonths"
          [weekDays]="facade.weekDays"
          [selectedDepartureDate]="facade.desktopSelectedDate"
          [isFlexibleDates]="!facade.isHotelsSearch && facade.isFlexibleDates"
          [showFlexibleDates]="!facade.isHotelsSearch"
          [hasLoadedAvailableDates]="facade.hasLoadedAvailableDates"
          [availableDateKeys]="facade.availableDateKeys"
          [minDateKey]="facade.minCheckInDateKey"
          [maxDateKey]="facade.maxCheckInDateKey"
          (prevMonth)="facade.prevCalendarMonth()"
          (nextMonth)="facade.nextCalendarMonth()"
          (dateSelected)="onDateSelected($event)"
          (flexibleDatesChange)="facade.setFlexibleDates($event)"
        />
      </div>
    }
  </div>

  @if (!facade.isHotelsSearch) {
    <div class="search-params-group" style="min-width: 210px">
      <button type="button"
              class="search-pill search-pill--nights"
              (click)="toggleDropdown('nights', $event)">
        <span class="pill-label">Кол-во дней:</span>
        <span class="pill-value">{{ facade.nightsLabel }}</span>
      </button>
      @if (openedDropdown === 'nights') {
        <div class="search-dropdown search-dropdown--nights" (click)="$event.stopPropagation()">
          <app-short-search-nights-dropdown
            [days]="facade.nightsOptionsDays"
            [nightsFrom]="facade.nightsFrom"
            [nightsTo]="facade.nightsTo"
            [pendingStartDay]="facade.pendingNightRangeStartDay"
            [hoveredDay]="facade.hoveredNightDay"
            [hint]="facade.nightsDropdownHint"
            (hovered)="facade.onNightHover($event)"
            (hoverLeft)="facade.onNightHoverLeave()"
            (selected)="selectNights($event)"
          />
        </div>
      }
    </div>
  } @else {
    <div class="search-params-group" style="min-width: 210px">
      <button type="button"
              class="search-pill search-pill--dates search-pill--check-out"
              (click)="toggleDropdown('checkOut', $event)">
        <span class="pill-label">{{ facade.checkOutTitle }}</span>
        <span class="pill-value">{{ facade.checkOutLabel }}</span>
      </button>
      @if (openedDropdown === 'checkOut') {
        <div class="search-dropdown search-dropdown--dates" (click)="$event.stopPropagation()">
          <app-short-search-dates-dropdown
            [months]="facade.calendarMonths"
            [weekDays]="facade.weekDays"
            [selectedDepartureDate]="facade.desktopSelectedDate"
            [isFlexibleDates]="false"
            [showFlexibleDates]="false"
            [hasLoadedAvailableDates]="false"
            [availableDateKeys]="facade.availableDateKeys"
            [minDateKey]="facade.minCheckOutDateKey"
            [maxDateKey]="facade.maxCheckOutDateKey"
            (prevMonth)="facade.prevCalendarMonth()"
            (nextMonth)="facade.nextCalendarMonth()"
            (dateSelected)="onDateSelected($event)"
          />
        </div>
      }
    </div>
  }

  <div class="search-params-group" style="width: 100%">
    <button type="button"
            class="search-pill search-pill--tourists"
            (click)="toggleDropdown('tourists', $event)">
      <span class="pill-label">Туристов:</span>
      <span class="pill-value">{{ facade.adultsLabel }}{{ facade.childLabel }}</span>
    </button>
    @if (openedDropdown === 'tourists') {
      <div class="search-dropdown" (click)="$event.stopPropagation()">
        <app-tourists [initialSearchParams]="facade.newSearchParams" />
      </div>
    }
  </div>

  <button type="button"
          class="search-submit"
          [class.search-submit--hotels-search]="facade.isHotelsSearch"
          (click)="onApply()">{{ facade.submitButtonLabel }}</button>
</div>
